import { useMemo, useRef } from "react";
import Draggable from 'react-draggable';
import _ from "lodash";

//MdArrowDropUp


const ProcessDesignerFlowChartGroup = (props) =>
{

  //Props
  const ReadOnly = props.ReadOnly;
  const Data = props.Data;
  const OnUpdateGroup = props.OnUpdateGroup;
  const SetCurrentMoving = props.SetCurrentMoving;
  const CopyMode = props.CopyMode;
  const CopyData = props.CopyData;
  const CurrentLinking = props.CurrentLinking;
  const IsSelected = useMemo(() => {
    if (CopyData){
      return CopyData.findIndex(c => c == Data._id) > -1;
    }

    return false;
  }, [CopyData, Data._id]);
  //const OnClickSelectCopy = props.OnClickSelectCopy;
  const NewCounter = props.NewCounter;
  const OnRightClickContextStep = props.OnRightClickContextStep;
  const LinkStepToGroup = props.LinkStepToGroup;
  const OnOpenGroup = props.OnOpenGroup;
  const Step = props.Step;
  const Entry = useMemo(() =>
  {
    return props.Step.filter(s => Data.entry.findIndex(d => d.processStep == s._id) > -1)
  }, [props.Step, Data.entry]);
  // const ChildrenStep = useMemo(() => {
  //   return props.Step.filter(s => s.parentGroup == Data._id)
  // }, [props.Step]);

  // || Data.entry.findIndex(d => d.processStep == s._id) > -1
  //UseRef
  const hideLineAndCondition = useRef(false);

  // const getNavigationButtonIcon = () =>
  // {

  //   switch (Data.navigationButton)
  //   {
  //     case "Home":
  //       return <MdHome />
  //     case "Back":
  //       return <RiArrowGoBackLine />
  //     default:
  //       return <MdOutlineForward />;
  //   }

  // };

  const onDragStart = (e, data) => {




    hideLineAndCondition.current = false;

  };

  const onDragOn = (e, data) =>
  {

    if (hideLineAndCondition.current == false)
    {

      // Get all div elements with the specified class
      let listArrow = document.querySelectorAll('line.processdesigner_flowchart_line');

      listArrow.forEach(line =>
      {

        let isFound = Step.some(c =>  line.id.includes("GROUP" + Data._id));

        //{"GROUP" + g._id + "CURRENT" + CurrentGroup[CurrentGroup.length - 1]._id}

        if (isFound)
        {
          line.style.display = 'none';
        }

      });





    }

    hideLineAndCondition.current = true;

  };


  const onDragEnd = (e, data) => {

    const listArrow = document.querySelectorAll('line.processdesigner_flowchart_line');

    listArrow.forEach(line =>
    {
      if (line.id != "Linking_Line")
        line.style.display = 'block';
    });

    let listCondition = document.querySelectorAll('div.processdesigner_flow_conditon');

    listCondition.forEach(condition =>
    {

      condition.style.display = 'block';

    });

    let newPosition = {
      x: data.lastX < 0 ? 0 : data.lastX,
      y: data.lastY < 0 ? 0 : data.lastY
    }

    if (newPosition.x == Data.position.x && newPosition.y == Data.position.y) return;

    let updatedGroup = _.cloneDeep(Data);

    updatedGroup.position = newPosition;


    SetCurrentMoving(undefined);
    OnUpdateGroup(updatedGroup);
  };

  const handleClick = () => {

    if (CurrentLinking.enabled && CurrentLinking.data._id != Data._id){


      LinkStepToGroup(CurrentLinking.data, Data);
    }
    // } else if (CopyMode){

    //   OnClickSelectCopy(Data._id);

    // }

  };



  return (
      <Draggable
        defaultPosition={{ x: Data.position.x, y: Data.position.y }}
        onStop={!ReadOnly && !CopyMode ? onDragEnd : undefined}
        onDrag={!ReadOnly && !CopyMode ? onDragOn : undefined}
        onStart={!ReadOnly && !CopyMode ? onDragStart : undefined}
        disabled={ReadOnly || CopyMode}
        bounds={{
          left: 0,
          top: 0,
          right: 5000,
          bottom: 20000
        }}
        grid={[10, 10]}

      >

      <div className={"processdesigner_flow_group_cont page_noselect " + (IsSelected ? "processdesigner_flow_item_cont_selected " : "") 
        + (NewCounter == Data.newCounter ? "processdesigner_flow_item_cont_new " : "")} 
        id={"Group_" + Data._id}
        onContextMenu={(e) => OnRightClickContextStep(e, {...Data, isGroup: true})}
        onClick={handleClick}
        onDoubleClick={() => OnOpenGroup(Data)}
          >
          <div className="processdesigner_flow_group_cont_tab">Group</div>
          <div className="processdesigner_flow_group_cont_content">
            <div className="processdesigner_flow_group_header">
              {Data.title}
            </div>
            <div className="processdesigner_flow_group_list">
              {Entry.map(s => (
                <div key={s._id} className="processdesigner_flow_group_list_item">
                  {s.title}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Draggable>
  );

}

export default ProcessDesignerFlowChartGroup;